import { Portal } from 'components/portal'
import { AnimatePresence } from 'framer-motion'
import { ImageBackdrop, ImagePopup } from './styled'
import { theme } from 'styles/theme'
import { FC } from 'react'

type Props = {
  openImageUrl: string
  onClose: () => void
}

export const Preview: FC<Props> = ({ openImageUrl, onClose }) => (
  <Portal>
    <AnimatePresence>
      {!!openImageUrl && (
        <>
          <ImageBackdrop
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.8 }}
            exit={{ opacity: 0, transition: { delay: 0.3 } }}
            transition={{
              type: 'tween',
              duration: 0.4,
            }}
          />
          <ImagePopup
            src={openImageUrl}
            alt=""
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{
              opacity: 1,
              scale: 1,
              transition: { delay: 0.3, ease: theme.easeValues.out },
            }}
            exit={{
              opacity: 0,
              scale: 0.95,
            }}
            transition={{ type: 'tween', duration: 0.4 }}
          />
        </>
      )}
    </AnimatePresence>
  </Portal>
)
